// extracted by mini-css-extract-plugin
export default {"placeholder":"dropdown_placeholder__Whm+p","menu":"dropdown_menu__JcgMU","control":"dropdown_control__heX1c","lg":"dropdown_lg__r1yD0","right":"dropdown_right__g9jxO"};